export default __webpack_public_path__ + "static/media/arte.3f9a52d3.gif";